import './style.scss';
import { useUserDetails } from '../../hooks/useUserDetails';
import { logoutUser } from '../../store/builder/loginSlice';
import { useDispatch } from 'react-redux';
import { setLoader } from '../../store/builder/reducer';
import { useTranslation } from '../../hooks/useTranslation';

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import routes from '../../utils/routes';

const SsoWarning = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { error, data } = useUserDetails({ retry: false });

  useEffect(() => {
    if (data) {
      navigate(routes.private.main);
    }
  }, [data]);

  const handleLogOut = () => {
        dispatch(setLoader(true));
        dispatch(logoutUser());
        dispatch(setLoader(false));
    };

  return (
    <div className="sso-warning">
      <div className="sso-warning__container">
        <h1 className="sso-warning__title">{t('ssoWarning.title')}</h1>
        <div className="sso-warning__alert">
          <div className="sso-warning__alert-icon">⚠️</div>
          <div className="sso-warning__alert-content">
            <div className="sso-warning__alert-title">{t('ssoWarning.alertTitle')}</div>
            <div className="sso-warning__alert-message">
              <div dangerouslySetInnerHTML={{__html: error?.response?.data?.message}} />
            </div>
          </div>
        </div>
        <div className="sso-warning__info">
          <div>{t('ssoWarning.signedInAs')} <b>{error?.response?.data?.email}</b></div>
          <div className="sso-warning__support">
            {t('ssoWarning.supportMessage')}
          </div>
          <div className="sso-warning__help">
            {t('ssoWarning.needHelp')} <a href="#" className="sso-warning__link">{t('ssoWarning.contactSupport')}</a>
          </div>
        </div>
        <div className="sso-warning__footer">
          <div className="sso-warning__other-account">{t('ssoWarning.notRightAccount')}</div>
          <div className="sso-warning__footer-buttons">
            <button className="sso-warning__logout" onClick={handleLogOut}>{t('actions.logout')}</button>
            <button className="sso-warning__refresh" onClick={() => window.location.reload()}>{t('actions.refresh')}</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SsoWarning;
